import $ from 'jquery';

function addToBag(code, size, event){
    if(!size || !code) return;
    var pdpData = window.rcProps.pdp || {};
    var sectionURL = pdpData.sectionURL;
    var sessionID = pdpData.sessionId;
    var retailPrice = pdpData.retailPrice;

    var cartItems = new Array();
    var cartItem = {};

    cartItem.productCode = code;
    cartItem.productName = pdpData.productName;
    cartItem.productCategory = pdpData.categoryName;
    cartItem.brandName = pdpData.brandName;
    cartItem.price = pdpData.price;
    cartItem.images = [];
    cartItem.size = size;
    cartItem.description = pdpData.description;
    cartItem.url = pdpData.url;
    cartItem.department = pdpData.department;
    cartItem.cat1 = pdpData.cat1;
    cartItems.push(cartItem);

    window.addProduct(code, size, sectionURL, sessionID, 1, function(){
        var data = $.param({
            code : code,
            size : size
        });

        $.modal({
            url: "/fw/ajax/AddToBagPopup.jsp",
            data: data,
            type: 'small',

            triggerOpen: true,
            returnFocus: event ? $(event.currentTarget) : "",
            onComplete : function(){
                updateBagCount();

                if (typeof gaAddToCartActionWithAjax === 'function'){
                    gaAddToCartActionWithAjax('add',code,size,1);
                }

                if (typeof insertGoogleRemarketingAddToCart === 'function') {
                    insertGoogleRemarketingAddToCart();
                }

                if (typeof insertFacebookAddToCart === 'function') {
                    insertFacebookAddToCart(code, retailPrice);
                }
                if (typeof addToCartYahoo === 'function'){
                    addToCartYahoo(code);
                }
                if (typeof insertCriteoAddToCart === 'function') {
                    insertCriteoAddToCart(code);
                }
                if (typeof iPinYouAddtoCart === 'function'){
                    iPinYouAddtoCart(code);
                }
                if (typeof insertKakaoAddToCart === 'function') {
                    insertKakaoAddToCart(code);
                }
                if (typeof insertRTBHouseAddToCart === 'function'){
                    insertRTBHouseAddToCart(code);
                }
                if(typeof insertTiktokAddToCart === "function"){
                    insertTiktokAddToCart(code);
                }
            }
        });
    });
}

function updateBagCount(){
    $.ajax(
        {url:"/fw/ajax/CartItemCount.jsp",cache:false}
    ).done(function(msg){
        if(msg.bagCount){
            $("#cart_item_count").text(msg.bagCount);
        }
        else{
            console.error("cart item message cannot be parsed");
        }
    });
}

export default addToBag;


// WEBPACK FOOTER //
// ./src/scripts/entry-points/pdp/add-to-bag.js